import { render } from "./ButtonDestination.vue?vue&type=template&id=553efdca"
import script from "./ButtonDestination.vue?vue&type=script&lang=js"
export * from "./ButtonDestination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__